import {createSelector} from 'reselect';
import getPaymentOptionsFromOrderSummary from './getPaymentOptionsFromOrderSummary';
import getPaymentOptionsPermittedByDeliveryOption from './getPaymentOptionsPermittedByDeliveryOption';
import {getPaymentOptions} from './PaymentOptionSelectors';

const makeIsPaymentOptionDisabledByOrderSummaryPaymentOptions = paymentType => createSelector(
  [getPaymentOptions, getPaymentOptionsFromOrderSummary],
  (paymentOptionsStart, paymentOptionsOrderSummary) => paymentOptionsOrderSummary !== undefined
    && paymentOptionsOrderSummary.length > 0
    && paymentOptionsStart.some(paymentOption => paymentOption.type === paymentType)
    && !paymentOptionsOrderSummary.some(paymentOption => paymentOption.type === paymentType),
);

export default makeIsPaymentOptionDisabledByOrderSummaryPaymentOptions;
